
class AgeRange {

    private literal: string;
    constructor(private from: number, private to: number, literal?: string) {  
        this.literal = literal?literal:`${from}-${to}`;
    }

    public getRange(): number[] {
        return [this.from, this.to];
    }

    public getLiteral(): string {
        return this.literal;
    }

    public isInRange(age: number): boolean {
        return (age >= this.from && age <= this.to);
    }   

    
}

const breakPoints = [18, 25, 35, 45, 55, 65, 75];

const AgeRanges: AgeRange[] = [];

for(let i=-1; i<breakPoints.length; i++) {
    const from = i<0?-1:breakPoints[i];
    const to = i<breakPoints.length-1?breakPoints[i+1]-1:-1;  
    
    if(from<0) {
        AgeRanges.push(new AgeRange(0, to, `${to}-`));
    }
    else if (to<0) {
        AgeRanges.push(new AgeRange(from, 10000, `${from}+`));
    }
    else {
        AgeRanges.push(new AgeRange(from, to));
    }
}


function getRangeByAge(age: number): AgeRange {
    return AgeRanges.find(x => x.isInRange(age));
}

const NullAgeRange = new AgeRange(-1, -1, "");

export { AgeRanges, getRangeByAge, AgeRange, NullAgeRange};

 